/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Basic_FootnoteInputs */

const ja_playdata_pricing_basic_footnote = /** @type {(inputs: Playdata_Pricing_Basic_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3日分の統計は基本料金50,000円に含まれます。4日目以降は追加料金5,000円/日が加算されます。`)
};

const en_playdata_pricing_basic_footnote = /** @type {(inputs: Playdata_Pricing_Basic_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data for 3 days is included in the base fee of ¥50,000. From the 4th day onwards, a charge of ¥5,000/day is added.`)
};

/**
* | output |
* | --- |
* | "Data for 3 days is included in the base fee of ¥50,000. From the 4th day onwards, a charge of ¥5,000/day is added." |
*
* @param {Playdata_Pricing_Basic_FootnoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_basic_footnote = /** @type {((inputs?: Playdata_Pricing_Basic_FootnoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Basic_FootnoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_basic_footnote(inputs)
	return en_playdata_pricing_basic_footnote(inputs)
});